import React, { useState } from 'react';
import data from '../data.json';

export default function Testimonials() {
  const [active, setActive] = useState(0);
  const reviews = data.testimonials;

  return (
    <section id="testimonials" style={{
      padding: '110px 0', background: 'var(--bg-dark)',
      position: 'relative', overflow: 'hidden',
    }}>
      {/* Subtle glow */}
      <div style={{
        position: 'absolute', width: 500, height: 500, borderRadius: '50%',
        background: 'radial-gradient(circle, rgba(0,194,168,0.05) 0%, transparent 70%)',
        top: '50%', right: '-8%', transform: 'translateY(-50%)', pointerEvents: 'none',
      }} />

      <div className="container">
        <div style={{ textAlign: 'center', marginBottom: 60 }}>
          <div className="section-label center">Client Stories</div>
          <h2 className="section-title">Early Believers. Real Feedback.</h2>
          <p className="section-sub" style={{ margin: '0 auto', maxWidth: 520 }}>
            We're new — and these are the clients who took a chance on us first. Their honest words mean everything to us.
          </p>
        </div>

        <div style={{
          display: 'grid', gridTemplateColumns: 'repeat(2,1fr)', gap: 20,
        }} className="testi-grid">
          {reviews.map((t, i) => (
            <div key={t.id} onClick={() => setActive(i)} style={{
              background: active === i ? 'rgba(255,107,43,0.05)' : 'var(--bg-card)',
              border: `1px solid ${active === i ? 'rgba(255,107,43,0.35)' : 'var(--border)'}`,
              borderRadius: 'var(--radius)', padding: 28, cursor: 'pointer',
              transition: 'all var(--ease)', position: 'relative',
              transform: active === i ? 'translateY(-3px)' : 'none',
              boxShadow: active === i ? '0 16px 40px rgba(0,0,0,0.35)' : 'none',
            }}>
              {/* Quote mark */}
              <div style={{
                position: 'absolute', top: 18, right: 22,
                fontSize: 46, color: 'var(--accent)', opacity: 0.1,
                fontFamily: 'serif', lineHeight: 1,
              }}>❝</div>

              {/* Stars */}
              <div style={{ display: 'flex', gap: 3, marginBottom: 15 }}>
                {Array.from({ length: t.rating }).map((_, j) => (
                  <span key={j} style={{ color: 'var(--accent3)', fontSize: 13 }}>★</span>
                ))}
              </div>

              <p style={{
                color: active === i ? 'rgba(255,255,255,0.9)' : 'var(--gray-400)',
                fontSize: 13.5, lineHeight: 1.82, fontStyle: 'italic',
                marginBottom: 20, transition: 'color var(--ease)',
              }}>
                "{t.text}"
              </p>

              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                  width: 44, height: 44, borderRadius: '50%', flexShrink: 0,
                  background: active === i
                    ? 'linear-gradient(135deg, var(--accent), var(--accent2))'
                    : 'var(--bg-card2)',
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  fontWeight: 800, fontSize: 13, color: '#fff',
                  border: active === i ? 'none' : '2px solid var(--border)',
                  transition: 'all var(--ease)',
                }}>
                  {t.avatar}
                </div>
                <div>
                  <div style={{ fontWeight: 800, color: '#fff', fontSize: 13.5, marginBottom: 1 }}>{t.name}</div>
                  <div style={{ fontSize: 11.5, color: 'var(--gray-500)' }}>{t.role}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div style={{
          marginTop: 60, textAlign: 'center', padding: 50,
          background: 'linear-gradient(135deg, rgba(255,107,43,0.08), rgba(0,194,168,0.06))',
          borderRadius: 18, border: '1px solid rgba(255,107,43,0.18)',
        }}>
          <h3 style={{
            fontSize: '1.75rem', fontWeight: 900, color: '#fff',
            marginBottom: 11, letterSpacing: '-0.025em',
          }}>
            Be Part of Our Growth Story
          </h3>
          <p style={{ color: 'var(--gray-400)', marginBottom: 28, fontSize: 15 }}>
            Join the brands giving Vylinx their trust — and let's build something remarkable together.
          </p>
          <a href="#contact" className="btn-primary" style={{ fontSize: 15, padding: '14px 34px' }}>
            Let's Talk →
          </a>
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .testi-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </section>
  );
}
